exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.f-title[data-v-ab96f92a] {\n  font-size: 1.8rem;\n}\n.coming-soon[data-v-ab96f92a] {\n  float: right;\n  top: -46px;\n  position: relative;\n  border-bottom-right-radius: 0px;\n  border-top-left-radius: 0px;\n}\n", ""]);

// exports
